import { t } from "i18next";
import type { FC } from "react";

import { SelectionButton } from "../SelectionButton";
import { format2Dec } from "utils/number-to-short-version";
import { TimeInstant, TimeDelayed } from "utils/svg-icons";

export interface UnstakeMethodSelectionBodyProps {
  currentIsUnstakeDelayed: boolean;
  remainingLabel: string;
  instantFeePct?: number;
  solAmount?: number;
  priceAmount?: number;
  onUnstakeMethodChange: (isDelayed: boolean) => void;
}

export const UnstakeMethodSelectionBody: FC<
  UnstakeMethodSelectionBodyProps
> = ({
  currentIsUnstakeDelayed,
  remainingLabel,
  instantFeePct,
  solAmount,
  priceAmount,
  onUnstakeMethodChange,
}) => {
  const feeMultiplier = instantFeePct ? 1 - instantFeePct / 100 : 1;
  return (
    <div className="w-full flex flex-col gap-2 md:pb-4">
      <SelectionButton
        title={t("app.unstaking.instant.description")}
        titleExtra={
          solAmount && instantFeePct
            ? `${format2Dec(solAmount * feeMultiplier)} SOL`
            : undefined
        }
        subtitle={
          instantFeePct
            ? t("app.unstaking.price-impact").replace(
                "{{pct}}",
                format2Dec(instantFeePct)
              )
            : undefined
        }
        subTitleExtra={
          priceAmount && instantFeePct ? (
            <p className="text-secondary-text">{`$${format2Dec(
              priceAmount * feeMultiplier
            )}`}</p>
          ) : (
            ""
          )
        }
        description={t("app.unstaking.instant.label")}
        icon={<TimeInstant />}
        selected={!currentIsUnstakeDelayed}
        onClick={() => onUnstakeMethodChange(false)}
      />
      <SelectionButton
        title={remainingLabel}
        titleExtra={
          solAmount && instantFeePct
            ? `${format2Dec(solAmount)} SOL`
            : undefined
        }
        subtitle={
          instantFeePct
            ? t("app.unstaking.price-impact").replace("{{pct}}", "0")
            : undefined
        }
        subTitleExtra={
          priceAmount && instantFeePct ? (
            <p className="text-secondary-text">{`$${format2Dec(
              priceAmount
            )}`}</p>
          ) : (
            ""
          )
        }
        description={t("app.unstaking.delayed.label")}
        selected={currentIsUnstakeDelayed}
        icon={<TimeDelayed />}
        onClick={() => onUnstakeMethodChange(true)}
      />
    </div>
  );
};
